// src/modules/app-views/invoices/components/InvoiceTypesTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import SimpleTag from 'components/SimpleComponents/SimpleTag';
import translateX from 'utils/translateX';
import invoicesService from 'modules/app-views/invoices/service';
import fiscalService from 'services/fiscalService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InvoiceTypesTag = ({ data, tags, style }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const items = tags || (data?.documentType ? [data.documentType] : []);

  const typeTags = items?.map((item, idx) => {
    const typeColor = invoicesService.getInvoiceTypeColor(item);
    const label = fiscalService.getDocumentTypeLabel(item);
    return {
      key: idx,
      label: label || translateX(item?.toLowerCase()),
      color: typeColor,
      textColor: typeColor,
    };
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  const filteredTags = typeTags?.filter(i => i?.label);

  // Fixed background to maintain consistent look in both light and dark themes
  const fixedStyle = { backgroundColor: '#fafafa', ...style };

  // Single tag: render directly without Flex wrapper for better alignment
  if (filteredTags?.length === 1) {
    const tag = filteredTags[0];
    return (
      <Tag
        color={tag.color}
        variant="outlined"
        style={fixedStyle}
        // style={style}
      >
        <span style={tag.textColor ? { color: tag.textColor } : undefined}>
          {translateX(tag.label)}
        </span>
      </Tag>
    );
  }

  // Multiple tags: use SimpleTag with Flex wrapper
  return (
    <SimpleTag
      tags={filteredTags}
      variant="outlined"
      tagStyle={fixedStyle}
      // tagStyle={style}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InvoiceTypesTag;

// *******************************************************************************
// HELPERS
// *******************************************************************************

const a = {
  isTestDocument: false,
  _id: '698307e8103723c167fc1e9f',
  _metadata: {
    subscriptionId: '6980f3ef88da1b5b60f3df96',
    companyId: '6982433ca1cd6cd67752cd25',
    createdAt: '2026-02-03T03:00:00.000Z',
    updatedAt: '2026-02-04T08:48:40.384Z',
    status: 'active',
    documentStatus: 0,
    level: 1,
    system: false,
    origin: 1,
    originMigration: 'lekkus',
    migratedFrom: 'migraCE',
    hidden: false,
    audit: {
      createdOnClient: {
        userAgent: 'Migration/migraCE',
        acceptLanguage: 'pt-BR',
      },
      createdInRequestCode: 'MIGRA0',
      updatedOnClient: {
        userAgent:
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36',
        acceptLanguage: 'pt-BR',
      },
      updatedInRequestCode: 'BH5PKC',
      createdAt: '2026-02-03T03:00:00.000Z',
      updatedAt: '2026-02-04T13:48:06.054Z',
      updatedByAccountId: '69722baa9996edf3ec46936e',
      updatedFromIp: {
        city: 'São Paulo',
        country: 'BR',
        ip: '177.62.38.54',
        lat: -23.5475,
        lon: -46.6361,
        org: 'AS26599 TELEFÔNICA BRASIL S.A',
        provider: 'ipinfo',
        region: 'São Paulo',
        state: 'SP',
        zip: '01000-000',
      },
    },
    i18n: {
      countryCode: 'BR',
      timezoneOffset: -180,
      languageCode: 'pt-BR',
      localeCode: 'BR',
    },
    documentCode: 'fc1e9f',
    counter: 4056,
    __documentCode: '4056.fc1e9f',
    __origin: 'migrated',
    __documentStatus: 'in_analysis',
  },
  legacyCode: ['160345'],
  orderLegacyCode: ['172890'],
  documentType: 'nfce',
  status: 'authorized',
  environment: 'homologation',
  documentSerie: 1,
  model: 65,
  purpose: 'normal',
  operationType: 'exit',
  consumerPresence: 'inPerson',
  destinationCode: 1,
  isFinalConsumer: true,
  operationNature: 'Venda',
  intermediation: 'own',
  issueDate: '2026-02-03T03:00:00.000Z',
  issuer: {
    entityId: '6982433ca1cd6cd67752cd25',
    cnpj: '49604952000103',
    name: 'Ezematel Materiais Eletricos Ltda',
    tradeName: 'EZEMATEL MATERIAIS ELETRICOS LTDA.',
    stateRegistration: '244204484119',
    taxRegime: 'simples_nacional',
    taxRegimeCode: 1,
    address: {
      zip: '13010080',
      address1: 'Avenida Campos Salles',
      number: '322',
      neighborhood: 'Centro',
      city: 'Campinas',
      cityCode: '3509502',
      region: 'SP',
      countryCode: 'BR',
    },
  },
  recipient: {
    entityId: '69825f5176756d1bdf6df202',
    legacyCode: '5456',
    name: 'CONSUMIDOR FINAL',
    stateRegistrationIndicator: 9,
    address: {
      zip: '13010080',
      address1: 'AV. CAMPOS SALES',
      number: 'SN',
      neighborhood: 'CENTRO',
      city: 'CAMPINAS',
      cityCode: '3509502',
      region: 'SP',
      countryCode: 'BR',
    },
    isGenericPerson: false,
    cpfCnpj: '28100151806',
  },
  items: [
    {
      itemNumber: 1,
      productId: '69825f3876756d1bdf6df1ac',
      legacyCode: '976',
      orderLegacyCode: '172890',
      productSku: '976',
      description: 'ABRAC NYLON BRANCA 280 X 4,8MM DMI GT280ST',
      ncm: '39269090',
      cfop: '5405',
      unit: 'UN',
      quantity: 10,
      unitValue: 0.43,
      taxableUnit: 'UN',
      taxableQuantity: 10,
      taxableUnitValue: 0.43,
      totalValue: 4.3,
      discountValue: 0,
      discountPercentage: 0,
      approximateTaxes: 1.35,
      taxes: {
        icms: {
          origin: 0,
          csosn: '500',
          baseValue: 0,
          rate: 0,
          value: 0,
          baseReduction: 0,
          applySt: true,
          mvaRate: 0,
          stBase: 0,
          stRate: 0,
          stValue: 0,
        },
        pis: {
          cst: '49',
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        cofins: {
          cst: '49',
          baseValue: 4.3,
          rate: 0,
          value: 0,
        },
        ipi: {
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        ibscbs: {
          state: {
            rate: 0.005,
            value: 0.02,
          },
          city: {
            rate: 0.005,
            value: 0.02,
          },
          cbs: {
            rate: 0.009,
            value: 0.04,
          },
          cst: '101',
          classification: '101001',
          baseValue: 4.3,
        },
      },
      _validation: {
        isValid: true,
        errorList: [],
      },
    },
    {
      itemNumber: 2,
      productId: '6982a9b1103723c167fb1e9f',
      legacyCode: '1424',
      orderLegacyCode: '172890',
      productSku: '1424',
      description: 'FITA ISOLANTE 10MT AMARELA IMPERIAL 3M',
      ncm: '39191020',
      cfop: '5405',
      unit: 'UN',
      quantity: 1,
      unitValue: 8.9,
      taxableUnit: 'UN',
      taxableQuantity: 1,
      taxableUnitValue: 8.9,
      totalValue: 8.9,
      discountValue: 0,
      discountPercentage: 0,
      approximateTaxes: 3.61,
      taxes: {
        icms: {
          origin: 0,
          csosn: '500',
          baseValue: 0,
          rate: 0,
          value: 0,
          baseReduction: 0,
          applySt: true,
          mvaRate: 0,
          stBase: 0,
          stRate: 0,
          stValue: 0,
        },
        pis: {
          cst: '49',
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        cofins: {
          cst: '49',
          baseValue: 8.9,
          rate: 0,
          value: 0,
        },
        ipi: {
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        ibscbs: {
          state: {
            rate: 0.005,
            value: 0.04,
          },
          city: {
            rate: 0.005,
            value: 0.04,
          },
          cbs: {
            rate: 0.009,
            value: 0.08,
          },
          cst: '101',
          classification: '101001',
          baseValue: 8.9,
        },
      },
      _validation: {
        isValid: true,
        errorList: [],
      },
    },
    {
      itemNumber: 3,
      productId: '6982a9b2103723c167fb1ea8',
      legacyCode: '1425',
      orderLegacyCode: '172890',
      productSku: '1425',
      description: 'FITA ISOLANTE 10MT AZUL IMPERIAL 3M',
      ncm: '39191020',
      cfop: '5405',
      unit: 'UN',
      quantity: 1,
      unitValue: 8.9,
      taxableUnit: 'UN',
      taxableQuantity: 1,
      taxableUnitValue: 8.9,
      totalValue: 8.9,
      discountValue: 0,
      discountPercentage: 0,
      approximateTaxes: 3.61,
      taxes: {
        icms: {
          origin: 0,
          csosn: '500',
          baseValue: 0,
          rate: 0,
          value: 0,
          baseReduction: 0,
          applySt: true,
          mvaRate: 0,
          stBase: 0,
          stRate: 0,
          stValue: 0,
        },
        pis: {
          cst: '49',
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        cofins: {
          cst: '49',
          baseValue: 8.9,
          rate: 0,
          value: 0,
        },
        ipi: {
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        ibscbs: {
          state: {
            rate: 0.005,
            value: 0.04,
          },
          city: {
            rate: 0.005,
            value: 0.04,
          },
          cbs: {
            rate: 0.009,
            value: 0.08,
          },
          cst: '101',
          classification: '101001',
          baseValue: 8.9,
        },
      },
      _validation: {
        isValid: true,
        errorList: [],
      },
    },
    {
      itemNumber: 4,
      productId: '69826e3e103723c167fa6112',
      legacyCode: '4853',
      orderLegacyCode: '172890',
      productSku: '4853',
      description: 'LAMP LED TUBO 120CM T8 18W 6500K BIVOLT BLUMENAU LEDBEE 1371',
      ncm: '85395200',
      cfop: '5405',
      unit: 'UN',
      quantity: 2,
      unitValue: 11.9,
      taxableUnit: 'UN',
      taxableQuantity: 2,
      taxableUnitValue: 11.9,
      totalValue: 23.8,
      discountValue: 0,
      discountPercentage: 0,
      approximateTaxes: 8.5,
      taxes: {
        icms: {
          origin: 0,
          csosn: '500',
          baseValue: 0,
          rate: 0,
          value: 0,
          baseReduction: 0,
          applySt: true,
          mvaRate: 0,
          stBase: 0,
          stRate: 0,
          stValue: 0,
        },
        pis: {
          cst: '49',
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        cofins: {
          cst: '49',
          baseValue: 23.8,
          rate: 0,
          value: 0,
        },
        ipi: {
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        ibscbs: {
          state: {
            rate: 0.005,
            value: 0.12,
          },
          city: {
            rate: 0.005,
            value: 0.12,
          },
          cbs: {
            rate: 0.009,
            value: 0.21,
          },
          cst: '101',
          classification: '101001',
          baseValue: 23.8,
        },
      },
      _validation: {
        isValid: true,
        errorList: [],
      },
    },
    {
      itemNumber: 5,
      productId: '69826f58103723c167fa6554',
      legacyCode: '9197',
      orderLegacyCode: '172890',
      productSku: '9197',
      description: 'PARAF E BUCHA S8 PHS 4X45 25PC BESTFER BFH0925',
      ncm: '73181500',
      cfop: '5102',
      unit: 'PC',
      quantity: 1,
      unitValue: 10.9,
      taxableUnit: 'PC',
      taxableQuantity: 1,
      taxableUnitValue: 10.9,
      totalValue: 10.9,
      discountValue: 0,
      discountPercentage: 0,
      approximateTaxes: 3.89,
      taxes: {
        icms: {
          origin: 0,
          csosn: '102',
          baseValue: 0,
          rate: 0,
          value: 0,
          baseReduction: 0,
          applySt: false,
          mvaRate: 0,
          stBase: 0,
          stRate: 0,
          stValue: 0,
        },
        pis: {
          cst: '49',
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        cofins: {
          cst: '49',
          baseValue: 10.9,
          rate: 0,
          value: 0,
        },
        ipi: {
          baseValue: 0,
          rate: 0,
          value: 0,
        },
        ibscbs: {
          state: {
            rate: 0.005,
            value: 0.05,
          },
          city: {
            rate: 0.005,
            value: 0.05,
          },
          cbs: {
            rate: 0.009,
            value: 0.1,
          },
          cst: '101',
          classification: '101001',
          baseValue: 10.9,
        },
      },
      _validation: {
        isValid: true,
        errorList: [],
      },
    },
  ],
  totals: {
    productsAmount: 56.8,
    servicesAmount: 0,
    discountAmount: 0,
    freightAmount: 0,
    insuranceAmount: 0,
    otherExpensesAmount: 0,
    taxAmount: 0,
    icmsBaseAmount: 0,
    icmsAmount: 0,
    icmsStBaseAmount: 0,
    icmsStAmount: 0,
    pisAmount: 0,
    cofinsAmount: 0,
    ipiAmount: 0,
    ibsStateAmount: 0.28,
    ibsCityAmount: 0.28,
    cbsAmount: 0.51,
    approximateTaxes: 20.96,
    documentAmount: 56.8,
  },
  payment: {
    indicator: 0,
    methods: [
      {
        type: 'CREDIT_CARD',
        code: '03',
        amount: 56.8,
        description: 'Cartão de Crédito',
      },
    ],
    change: 0,
  },
  logistics: {
    volumes: {
      quantity: 15,
      packagingType: 'UN',
      grossWeight: 0,
      netWeight: 0,
    },
    freightModeCode: 'noFreight',
  },
  additionalInfo:
    'DOCUMENTO EMITIDO POR ME OU EPP OPTANTE PELO SIMPLES NÃO GERA DIREITO AO CREDITO FISCAL DE ISS E IPI.',
  migrationInfo: {
    origin: 'lekkus',
    migratedAt: '2026-02-04T08:48:40.384Z',
    condition: 'new',
    elapsedTimeMs: 114,
    cost: {
      costUSD: 0,
      costBRL: 0,
      exchangeRate: 6,
      exchangeRateSource: 'fallback',
      markupPercentage: 50,
      finalCostBRL: 0,
    },
  },
  note: 'Migrado do sistema Lekkus ERP | Tempo: 0.1s | Data: 04/02/2026',
  documentValidation: {
    isValid: true,
    lastValidatedAt: '2026-02-04T13:48:06.054Z',
    validationLevel: 'emission',
    errorList: [],
    warningList: [],
    providerValidationId: 'nfc_3a1f403c35c6400e9bab1c57d07188e1',
  },
  indexFields:
    '410480488 | 35260249604952000103650014104804881265267485 | consumidor final | 28100151806 | 5456 | ezematel materiais eletricos ltda | 49604952000103 | abrac nylon branca 280 x 4,8mm dmi gt280st | fita isolante 10mt amarela imperial 3m | fita isolante 10mt azul imperial 3m | lamp led tubo 120cm t8 18w 6500k bivolt blumenau ledbee 1371 | paraf e bucha s8 phs 4x45 25pc bestfer bfh0925 | 160345',
  documentNumber: 410480488,
  accessKey: '35260249604952000103650014104804881265267485',
  fiscalEngine: {
    providerCode: 'pachamama',
    providerId: 'nfc_3a1f403c35c6400e9bab1c57d07188e1',
    environment: 'homologation',
    statusCode: '100',
    statusMessage: 'Autorizado o uso da NF-e',
    authorizationDate: null,
  },
  attachments: [
    {
      attachmentId: '69834e17258774699fdc5036',
      attachmentType: 'document',
      storageUrl: '...',
      storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/document/pi9y35-1770212886195.pdf',
      base64Thumb: null,
      mimeType: 'application/pdf',
      originalName: 'DANFE-NFCE-410480488.pdf',
      label: 'DANFE NFCE 410480488',
      sortOrder: 0,
      isPrimary: false,
      tags: ['danfe', 'nfce', 'fiscal'],
      _id: '69834e17258774699fdc5043',
      id: '69834e17258774699fdc5043',
    },
    {
      attachmentId: '69834e17258774699fdc503a',
      attachmentType: 'document',
      storageUrl: '...',
      storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/document/5fypt4-1770212887198.xml',
      base64Thumb: null,
      mimeType: 'application/xml',
      originalName: 'NFCE-410480488.xml',
      label: 'XML NFCE 410480488',
      sortOrder: 0,
      isPrimary: false,
      tags: ['xml', 'nfce', 'fiscal'],
      _id: '69834e17258774699fdc5044',
      id: '69834e17258774699fdc5044',
    },
    {
      attachmentId: '69834e17258774699fdc503e',
      attachmentType: 'avatar',
      storageUrl: '...',
      storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/avatar/su2l94-1770212887483.png',
      base64Thumb: '...',
      mimeType: 'image/png',
      originalName: 'QRCODE-NFCE-410480488.png',
      label: 'QR Code NFCE 410480488',
      sortOrder: 0,
      isPrimary: true,
      tags: ['qrcode', 'nfce', 'fiscal'],
      _id: '69834e17258774699fdc5045',
      id: '69834e17258774699fdc5045',
    },
  ],
  issuerEntity: {
    _id: '6982433ca1cd6cd67752cd25',
    uniqueKey: '49604952000103',
    name: 'Ezematel Materiais Eletricos Ltda',
    firstName: 'Ezematel',
    middleName: 'Materiais Eletricos',
    lastName: 'Ltda',
    entityType: 'company',
    entityProfile: ['customer', 'company'],
    countryCode: 'BR',
    backColor: '#FFFFFF',
    foreColor: '#000000',
    foundedAt: '1982-04-07T00:00:00.000Z',
    segment: 'G',
    registrationStatus: {
      date: '2000-12-23T00:00:00.000Z',
      code: '2',
      description: 'Ativa',
    },
    mainActivity: {
      code: '4742300',
      description: 'Comercio Varejista De Material Eletrico',
    },
    legalNature: {
      code: '2062',
      description: 'Sociedade Empresaria Limitada',
    },
    legacyCode: ['2', '2352'],
    externalIds: [],
    genericPerson: false,
    genericCompany: false,
    finalConsumer: false,
    phone: {
      contactType: 'phone',
      phoneType: 'landline',
      value: '1932313534',
      countryCode: 'BR',
      purpose: [],
      isPrimary: false,
      isVerified: false,
      canReceiveSMS: false,
      canReceiveEmail: false,
      canReceiveWhatsApp: false,
      canReceiveVoiceCall: false,
      hasWhatsApp: false,
      _id: '6982433ca1cd6cd67752cd27',
      createdAt: '2026-02-03T18:51:55.133Z',
      updatedAt: '2026-02-03T18:51:55.133Z',
    },
    email: {
      contactType: 'email',
      value: 'financeiro@grupoce.com.br',
      countryCode: 'BR',
      purpose: [],
      isPrimary: false,
      isVerified: false,
      canReceiveSMS: false,
      canReceiveEmail: false,
      canReceiveWhatsApp: false,
      canReceiveVoiceCall: false,
      hasWhatsApp: false,
      _id: '6982433ca1cd6cd67752cd28',
      createdAt: '2026-02-03T18:51:55.133Z',
      updatedAt: '2026-02-03T18:51:55.133Z',
    },
    address: {
      countryCode: 'BR',
      addressType: ['main'],
      isPrimary: false,
      isActive: true,
      zip: '13010080',
      address1: 'Avenida Campos Salles',
      address2: null,
      number: '322',
      addressTitle: 'Endereço Principal',
      neighborhood: 'Centro',
      city: 'Campinas',
      cityCode: '3509502',
      region: 'SP',
      addressCoordinates: [-22.9069699, -47.0651258],
      addressAdditionalInfo: {
        searchApi: 'viacep',
        note: '',
        areaCode: '19',
        giaCode: '2446',
        ibgeCode: '3509502',
        siafiCode: '6291',
      },
      addressMetadata: {
        countryCode: 'BR',
        foundByApi: true,
        apiUrl: 'https://viacep.com.br/ws/13010080/json/',
        zipWithMultipleAddress: false,
        manual: false,
        apiFailure: false,
      },
      _id: '6982433ca1cd6cd67752cd29',
      createdAt: '2026-02-03T18:51:55.133Z',
      updatedAt: '2026-02-03T18:51:55.133Z',
    },
    cnpj: {
      documentType: 'cnpj',
      value: '49604952000103',
      countryCode: 'BR',
      isPrimary: false,
      isVerified: false,
      _id: '6982433ca1cd6cd67752cd26',
      createdAt: '2026-02-03T18:49:32.888Z',
      updatedAt: '2026-02-03T18:49:32.888Z',
    },
    ie: '244204484119',
    contacts: [
      {
        contactType: 'phone',
        phoneType: 'landline',
        value: '1932313534',
        countryCode: 'BR',
        purpose: [],
        isPrimary: false,
        isVerified: false,
        canReceiveSMS: false,
        canReceiveEmail: false,
        canReceiveWhatsApp: false,
        canReceiveVoiceCall: false,
        hasWhatsApp: false,
        _id: '6982433ca1cd6cd67752cd27',
        createdAt: '2026-02-03T18:51:55.133Z',
        updatedAt: '2026-02-03T18:51:55.133Z',
      },
      {
        contactType: 'email',
        value: 'financeiro@grupoce.com.br',
        countryCode: 'BR',
        purpose: [],
        isPrimary: false,
        isVerified: false,
        canReceiveSMS: false,
        canReceiveEmail: false,
        canReceiveWhatsApp: false,
        canReceiveVoiceCall: false,
        hasWhatsApp: false,
        _id: '6982433ca1cd6cd67752cd28',
        createdAt: '2026-02-03T18:51:55.133Z',
        updatedAt: '2026-02-03T18:51:55.133Z',
      },
    ],
    addresses: [
      {
        countryCode: 'BR',
        addressType: ['main'],
        isPrimary: false,
        isActive: true,
        zip: '13010080',
        address1: 'Avenida Campos Salles',
        address2: null,
        number: '322',
        addressTitle: 'Endereço Principal',
        neighborhood: 'Centro',
        city: 'Campinas',
        cityCode: '3509502',
        region: 'SP',
        addressCoordinates: [-22.9069699, -47.0651258],
        addressAdditionalInfo: {
          searchApi: 'viacep',
          note: '',
          areaCode: '19',
          giaCode: '2446',
          ibgeCode: '3509502',
          siafiCode: '6291',
        },
        addressMetadata: {
          countryCode: 'BR',
          foundByApi: true,
          apiUrl: 'https://viacep.com.br/ws/13010080/json/',
          zipWithMultipleAddress: false,
          manual: false,
          apiFailure: false,
        },
        _id: '6982433ca1cd6cd67752cd29',
        createdAt: '2026-02-03T18:51:55.133Z',
        updatedAt: '2026-02-03T18:51:55.133Z',
      },
    ],
    documents: [
      {
        documentType: 'cnpj',
        value: '49604952000103',
        countryCode: 'BR',
        isPrimary: false,
        isVerified: false,
        _id: '6982433ca1cd6cd67752cd26',
        createdAt: '2026-02-03T18:49:32.888Z',
        updatedAt: '2026-02-03T18:49:32.888Z',
      },
    ],
    attachments: [],
    fiscalData: {
      taxRegime: 'simples_nacional',
      mainCnae: '4742300',
      defaultIcmsRate: 0,
      defaultPisRate: 0,
      defaultCofinsRate: 0,
      defaultIpiRate: 0,
      nfse: {
        isEnabled: false,
        environment: 'homologation',
        providerStatus: 'pending',
        validationStatus: 'pending',
        currentSerie: 1,
        serie: 1,
        lastNumber: 0,
        municipal: {
          optanteSimplesNacional: true,
          incentivadorCultural: false,
        },
        numbering: {
          1: {
            lastNumber: 0,
            createdAt: '2026-02-03T18:49:32.878Z',
            pendingVoid: [],
          },
        },
      },
      defaultEnvironment: 'homologation',
      isActive: true,
      validationStatus: 'valid',
      taxRegimeCode: 1,
      fiscalCredentialId: '6982479ca1cd6cd67752cdba',
      stateRegistration: '244204484119',
      defaultIcmsCsosn: '101',
      nfce: {
        csc: {
          activatedAt: '2026-02-03T20:08:50.287Z',
          id: '1',
          isActive: true,
          token: '...',
          tokenMasked: '••••••••••••••••••••••••••••••••038e',
        },
        currentSerie: 1,
        environment: 'homologation',
        isEnabled: true,
        provider: 'pachamama',
        providerStatus: 'active',
        validatedAt: '2026-02-03T20:08:50.155Z',
        validationMessage: null,
        validationStatus: 'valid',
      },
    },
  },
  recipientEntity: {
    _id: '69825f5176756d1bdf6df202',
    uniqueKey: '28100151806',
    name: 'CONSUMIDOR FINAL',
    firstName: 'CONSUMIDOR',
    middleName: null,
    lastName: 'FINAL',
    entityType: 'person',
    entityProfile: ['customer'],
    countryCode: 'BR',
    backColor: '#FAFAFB',
    foreColor: '#000000',
    externalIds: [],
    genericPerson: false,
    genericCompany: false,
    finalConsumer: true,
    cpf: {
      documentType: 'cpf',
      value: '28100151806',
      countryCode: 'BR',
      isPrimary: true,
      isVerified: false,
      _id: '69825f5176756d1bdf6df203',
      createdAt: '2026-02-03T20:49:21.966Z',
      updatedAt: '2026-02-03T20:49:21.966Z',
    },
    contacts: [],
    addresses: [],
    documents: [
      {
        documentType: 'cpf',
        value: '28100151806',
        countryCode: 'BR',
        isPrimary: true,
        isVerified: false,
        _id: '69825f5176756d1bdf6df203',
        createdAt: '2026-02-03T20:49:21.966Z',
        updatedAt: '2026-02-03T20:49:21.966Z',
      },
    ],
    attachments: [],
  },
  referencedDocuments: [],
  displayNumber: null,
  isCanceled: false,
  isAuthorized: true,
  documentTypeLabel: 'NFC-e',
  avatar: {
    attachmentId: '69834e17258774699fdc503e',
    attachmentType: 'avatar',
    storageUrl: '...',
    storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/avatar/su2l94-1770212887483.png',
    base64Thumb: '...',
    mimeType: 'image/png',
    originalName: 'QRCODE-NFCE-410480488.png',
    label: 'QR Code NFCE 410480488',
    sortOrder: 0,
    isPrimary: true,
    tags: ['qrcode', 'nfce', 'fiscal'],
    _id: '69834e17258774699fdc5045',
    id: '69834e17258774699fdc5045',
  },
  documentAttachments: [
    {
      attachmentId: '69834e17258774699fdc5036',
      attachmentType: 'document',
      storageUrl: '...',
      storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/document/pi9y35-1770212886195.pdf',
      base64Thumb: null,
      mimeType: 'application/pdf',
      originalName: 'DANFE-NFCE-410480488.pdf',
      label: 'DANFE NFCE 410480488',
      sortOrder: 0,
      isPrimary: false,
      tags: ['danfe', 'nfce', 'fiscal'],
      _id: '69834e17258774699fdc5043',
      id: '69834e17258774699fdc5043',
    },
    {
      attachmentId: '69834e17258774699fdc503a',
      attachmentType: 'document',
      storageUrl: '...',
      storagePath: 'subscriptions/6980f3ef88da1b5b60f3df96/document/5fypt4-1770212887198.xml',
      base64Thumb: null,
      mimeType: 'application/xml',
      originalName: 'NFCE-410480488.xml',
      label: 'XML NFCE 410480488',
      sortOrder: 0,
      isPrimary: false,
      tags: ['xml', 'nfce', 'fiscal'],
      _id: '69834e17258774699fdc5044',
      id: '69834e17258774699fdc5044',
    },
  ],
};
